import React from 'react'
import styled from 'styled-components'

export default () => (
	<PlayIcon
		width='67px'
		height='67px'
		viewBox='0 0 117 117'
		version='1.1'
		xmlns='http://www.w3.org/2000/PlayIcon'
		xmlnsXlink='http://www.w3.org/1999/xlink'
	>
		<defs>
			<polygon id='path-1' points='0.0001 0 117 0 117 116.9998 0.0001 116.9998'></polygon>
		</defs>
		<g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
			<g id='play'>
				<g id='Group-3'>
					<mask id='mask-2' fill='white'>
						<use xlinkHref='#path-1'></use>
					</mask>
					<g id='Clip-2'></g>
					<path
						d='M58.5001,-0.0002 C90.8091,-0.0002 117.0001,26.1908 117.0001,58.4998 C117.0001,90.8088 90.8091,116.9998 58.5001,116.9998 C26.1911,116.9998 0.0001,90.8088 0.0001,58.4998 C0.0001,26.1908 26.1911,-0.0002 58.5001,-0.0002'
						id='Fill-1'
						fill='#FFFFFF'
						mask='url(#mask-2)'
					></path>
				</g>
				<polygon
					id='Stroke-4'
					stroke='#2E2E2C'
					strokeWidth='3'
					points='43.0001 84.4617 86.0001 56.7787 43.0001 32.5377'
				></polygon>
			</g>
		</g>
	</PlayIcon>
)

const PlayIcon = styled.svg`
	position: absolute;
	transform: translate(-50%, -50%);
	top: 50%;
	left: 50%;
`



// WEBPACK FOOTER //
// ./src/svg/play.js